import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import followUpManagerReducer from '../reducers/followUpManagerReducer';

const configureStore = (railsProps) => (
  createStore(followUpManagerReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
